define.alias("shared/components/shared/period-time-picker", "settings/components/shared/period-time-picker");